// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"1808a3bdb169ea61","228":"12b430c696d5f1e0"}[chunkId] + ".css";
};